module.exports = __webpack_public_path__ + "img/valuationResult2.c2c71cf6.png";